import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c624dd10&"
import script from "./exitPopup.js?vue&type=script&lang=js&"
export * from "./exitPopup.js?vue&type=script&lang=js&"
import style0 from "./styles.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports